import dynamic from 'next/dynamic';

export const ReportBottomSheet = dynamic(
  () => import('./reportSheetInternal').then((mod) => mod.GlobalReportBottomSheetComponent),
  {
    ssr: false,
  }
);
